// mixin.js
import { mapState } from 'vuex'

export const acl = {
  computed: {
    ...mapState('auth', ['userAdmin']),
  },
  methods: {
    can(action) {
      return this.userAdmin.permissions.includes(action)
    },
  },
}
